import { render } from 'preact'
import './styles/tokens.css'
import './styles/base.css'
import './styles/app.css'
import { initTheme } from './utils/theme'
import { App } from './app'

// Stamp the resolved theme on <html> before first paint — no flash.
initTheme()

const root = document.getElementById('app')!
render(<App />, root)
